import React, {useState} from 'react';
import {buildShareUrl} from './shareLink';

interface Props {
    payload: unknown;
    label?: string;
}

const ShareLinkButton: React.FC<Props> = ({payload, label = 'Отправить ссылку игроку'}) => {
    const [copied, setCopied] = useState(false);

    const handleClick = async () => {
        const url = buildShareUrl(payload);

        if (navigator.share) {
            try {
                await navigator.share({url});
                return;
            } catch {
                // user cancelled the share sheet or it's unsupported - fall back to clipboard
            }
        }

        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            window.prompt('Скопируй ссылку:', url);
        }
    };

    return (
        <button className="GmBtn" onClick={handleClick}>
            {copied ? 'Скопировано!' : label}
        </button>
    );
};

export default ShareLinkButton;
